import React, { useState } from 'react'
import { Link } from 'react-router-dom'
// CSS
import '../assets/css/blog-card.css'

export default function BlogCard(props) {
  const [categories, setCategories] = useState(props.categories);

  return (
    <div className='blog_card'>
      <Link to='/blogs/blog-1' className='thumbnail'>
        <img src={props.thumbnail} alt='blog' />
      </Link>
      <div className='details'>
        <Link className='title' to='/blogs/blog-1'>{props.title}</Link>
        <p>{props.description}</p>
        <div className='infos'>
          <a>{props.date}</a><p>|</p><Link to='/blogs/author/joe-doe'>{props.author}</Link><p>|</p> {
            categories.map((category, index) => {
              if(index === categories.length - 1) {
                return (
                  <Link key={index} to={'/blogs/category/'+category.link}>{category.name}</Link>
                )
              }
              else{
                return (
                  <>
                    <Link key={index} to={'/blogs/category/'+category.link}>{category.name}</Link>
                    <span>, </span>
                  </>
                )
              }
            })
          }
          <p>|</p><a><span className='fas fa-heart'></span> (10)</a>
        </div>
      </div>
      <Link to='/blog/blog-1' className='read_more'>Read More <span className='fas fa-plus'></span></Link>
    </div>
  )
}
